import { IDailyBonusItem } from '@/lib/types';

import { Observable } from './observable';

class DailyBonusStateService {
  readonly dailyBonusBlocks = new Observable<IDailyBonusItem[]>([]);
  readonly dailyBonusBlocksNextDate = new Observable<Date | null>(null);
  readonly dailyBonusIndexToCollect = new Observable<number>(0);

  clear = () => {
    this.dailyBonusBlocks.set([]);
    this.dailyBonusBlocksNextDate.set(null);
    this.dailyBonusIndexToCollect.set(0);
  };

  setDailyBonusBlocks = (blocks: IDailyBonusItem[]) => this.dailyBonusBlocks.set(blocks);
  setDailyBonusBlocksNextDate = (next: Date | null) => this.dailyBonusBlocksNextDate.set(next);
  setDailyBonusIndexToCollect = (index: number) => this.dailyBonusIndexToCollect.set(index);
}

export const dailyBonusStateService = new DailyBonusStateService();
